import React, {useState, useEffect, Fragment} from 'react';
import flatstore from 'flatstore';
import { currentLang } from '../../../utils/functions';
import {getRelatedProducts} from '../../../utils/services';
import ProductCard from '../ProductCard';
import {isNil, isArray} from 'lodash';
import W from '../Word';

function RelatedProducts({relatedType, relatedSlug, related_products_data}) {
    const [items, setItems] = useState(null);
    //console.log(relatedSlug, relatedType, related_products_data);
    useEffect(() => {
        related_products_data = null;
    }, [])

    useEffect(() => {
        if(isNil(related_products_data) && isNil(items)){
            getRelatedProducts(relatedType, relatedSlug);
        }
        if(related_products_data && related_products_data.length > 0 && isNil(items)){
            setItems(related_products_data);
        }
    }, [related_products_data])

    return (
        <Fragment>
            {items && isArray(items) && items.length > 0 &&
            <section className="bg--gray-light pt-80 pb-50">
                <div className="mb-40 text--center">
                    <h3 className="heading heading--h3 pr-30 pl-30"> <W>product.related_product_title</W> </h3>
                </div>
                <div className="pl-30 pr-30">
                    <div className="container-fluid">
                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-12 col-xxl-10">
                                <div className="row justify-content-center">
                                    {items.map((item, index)=>{
                                        return <div className="col-sm-6 col-md-6 col-xl-3"><ProductCard key={index} data={item} /></div>
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-30 text--center">
                    <a href={'/'+currentLang()} className="btn">
                        <span className="icon-magnify mr-10"></span>
                        <W>product.related_product_button_text</W>
                    </a>
                </div>
            </section>
            }
        </Fragment>
    )
}

export default flatstore.connect(['related_products_data'])(RelatedProducts);
